import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { Link } from "react-router-dom";
import { Form, Breadcrumb, Transfer, Spin, Col, Tooltip } from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import InputField from "../../common/htmlComponents/InputField";
import { getRequest, patchRequest, postRequest } from "../../axios";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
// import { authUserData } from "../../utils/Helper";

const AddUserRole = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formRef = useRef();

  const { id } = useParams();
  const UserRoleId = id ? atob(id) : null;

  const initialState = {
    // company: authUserData()?.company ? authUserData()?.company : null,
    // vendor: authUserData()?.vendor ? authUserData()?.vendor : null,
    group_name: null,
    permissions: [],
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnloading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const [mockData, setMockData] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);

  useEffect(() => {
    const getUserRoleDetail = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          "create-group-permissions/" + UserRoleId
        );
        if (apiResponse.data.success) {
          const formattedData = apiResponse.data.response.permissions.map(
            (item) => ({
              key: item.id,
              title: item.permission,
            })
          );
          setState({
            ...apiResponse.data.response,
            permissions: formattedData.map((item) => item.key),
            // vendor: authUserData()?.vendor ? authUserData()?.vendor : null,
            // company: authUserData()?.company ? authUserData()?.company : null,
          });
          setTargetKeys(formattedData.map((item) => item.key));
          formRef.current.setFieldsValue({
            ...apiResponse.data.response,
            group_name: apiResponse.data.response.group_name,
          });
        } else {
          // ErrorNotificationMsg(t("Error in get permission"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (UserRoleId !== null) {
      getUserRoleDetail();
    }
    getPermission();
  }, [UserRoleId, t]);

  useEffect(() => {
    setMockData(mockData);
  }, [mockData]);

  const getPermission = async () => {
    try {
      setapiloading(true);
      // const permissionArray = await getRequest("list-permission/");
      const permissionArray = await getRequest("create-group-permissions/");
    
      if (permissionArray.data.success) {
        if (permissionArray.data.response) {
          const formattedData = permissionArray.data.response[0].permissions.map((item) => ({
            key: item.id,
            title: item.permission,
            // title: item.name,
          }));
          setMockData(formattedData);
        }
        setapiloading(false);
      }
    } catch (error) {
      setapiloading(false);
      ErrorNotificationMsg("Error fetching permissions");
    }
  };

  const handleChange = (newTargetKeys) => {
    setTargetKeys(newTargetKeys);
    setState({ ...state, permissions: newTargetKeys });
  };

  const handleInputChange = (e) => {
    setState({ ...state, group_name: e.target.value });
  };

  const handleSubmit = async () => {
    let apiResponse;
    try {
      setBtnloading(true);
      if (UserRoleId === null) {
        apiResponse = await postRequest("create-group-permissions/", state);
      } else {
        apiResponse = await patchRequest(
          `create-group-permissions/${UserRoleId}/`,
          state
        );
      }

      if (apiResponse.data.success) {
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        SuccessNotificationMsg(
          UserRoleId === null
            ? t("user_role_added_successfully")
            : t("user_role_updated_successfully")
        );
        navigate("/user-role");
        setBtnloading(false);
      }
    } catch (err) {
      setBtnloading(false);
    }
  };
  const colors = ["#737373"];
  // const customValidator = () => {
  //   if (state.permissions.length === 0) {
  //     return Promise.reject("Please select at least one permission.");
  //   }
  //   return Promise.resolve();
  // };
  // const Permission_block = authUserData()?.permission.includes("user|view_authgrouppermissionsmodel") || authUserData()?.permission.includes("user|change_authgrouppermissionsmodel")
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
          {/* <Tooltip
                color={colors}
                placement="right"
                title={
                  <span style={{ color: "#fff" }}>
                    Create a new role to define specific permissions and access levels for users.
                  </span>
                }
              > */}
        {  UserRoleId ?<h3>Edit Role</h3>:<h3>Add Role</h3>}
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/user-role">{t("pl_roles")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
              {UserRoleId ? "Edit Role" : "Add Role"}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <section className="grid-sec FormSection flex-wrap">
        <div className="FormBody">
          <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
            <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
              <InputField
                className="Textarea"
                name="group_name"
                label={t("pl_designation_name")}
                placeholder={t("pl_enter_your_designation")}
                // prefix={<Name />}
                rules={t("val_designation1")}
                pattern={/^[a-zA-Z\s]+$/}
                handleInputChange={handleInputChange}
              />
            </Col>
            {/* {Permission_block && */}
            <Col md={24} lg={24} className="PermissionSec">
              <Form.Item
                name="permissions"
                label={t("pl_permission")}
                // rules={[
                //   {
                //     required: state.permissions.length === 0 && true,
                //     message: state.permissions.length === 0 && (
                //       <Trans>{t("please_select_permission")}</Trans>
                //     ),
                //   },
                // ]}
                // rules={[
                //   {
                //     //validator: customValidator,
                //   },
                // ]}
              >
                <Spin spinning={apiLoading}>
                  {/* {authUserData()?.permission.includes(
                      "user|change_authgrouppermissionsmodel"
                    ) && */}
                  <Transfer
                    dataSource={mockData}
                    showSearch
                    // listStyle={{
                    //   width: 500,
                    //   height: 300,
                    // }}
                    targetKeys={targetKeys}
                    onChange={handleChange}
                    render={(item) => item.title}
                  />
                  {/* } */}
                </Spin>
              </Form.Item>
            </Col>
            {/* } */}
            <div className="FormFooter">
              <ButtonField
                className="CancelGradiantBtn"
                type="primary"
                htmlType="button"
                size="medium"
                label={t("cancel")}
                onClick={() => navigate("/user-role")}
              />

              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Submit"
                size="medium"
                label={t("save")}
                loading={btnLoading}
              />
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};

export default AddUserRole;
